'use client';

import { FadeIn } from '../../animation/FadeIn.jsx';
import { cn } from '../../../lib/utils.js';

/**
 * Karten-Grid. item: { title, description?, features?: string[], href? }.
 */
export function FeatureGridBlock({ background, eyebrow, headline, items = [] }) {
  return (
    <section className={cn('py-20 md:py-32', background)}>
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        {(eyebrow || headline) && (
          <FadeIn>
            <div className="max-w-2xl mx-auto text-center mb-12 md:mb-16">
              {eyebrow && (
                <p className="text-accent-dark dark:text-accent font-semibold uppercase tracking-wider text-sm mb-2">
                  {eyebrow}
                </p>
              )}
              {headline && (
                <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-gray-900 dark:text-gray-100">
                  {headline}
                </h2>
              )}
            </div>
          </FadeIn>
        )}
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((item, i) => (
            <FadeIn key={i} delay={i * 0.1}>
              <div
                className={cn(
                  'relative rounded-lg p-8 h-full bg-white dark:bg-gray-900',
                  'border border-gray-100 dark:border-gray-700 shadow-sm transition-shadow',
                  item.href && 'group hover:shadow-lg hover:border-accent/40'
                )}
              >
                <div className="font-heading font-bold text-xl mb-3 text-gray-900 dark:text-gray-100 group-hover:text-accent-dark dark:group-hover:text-accent transition-colors">
                  {item.title}
                </div>
                {item.description && (
                  <p className="text-gray-700 dark:text-gray-300 mb-6">{item.description}</p>
                )}
                {item.features?.length > 0 && (
                  <ul className="space-y-2">
                    {item.features.map((f, j) => (
                      <li key={j} className="flex items-start gap-2 text-sm">
                        <span className="text-accent-dark dark:text-accent mt-1">{'→'}</span>
                        <span className="text-gray-600 dark:text-white/90">{f}</span>
                      </li>
                    ))}
                  </ul>
                )}
                {item.href && (
                  <a
                    href={item.href}
                    className="absolute inset-0 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
                  >
                    <span className="sr-only">{item.title}</span>
                  </a>
                )}
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
